import Vue from 'vue';

Vue.prototype.$style = {
  inputBox: {
    mandatory: '#C8E6C9',
  },
  listTotal: {
    filter: '#E8F5E9',
    result: '#C8E6C9'
  },
  purchase: {
    titlebar: '#C8E6C9',
  },
}
